<template>
  <nav
    class="navbar level is-fixed-bottom helvetica"
    role="navigation"
    id="bottom-navbar"
    aria-label="main navigation"
    v-if="$route.meta.hasBottomBar"
    style="margin-bottom: 0"
  >
    <div class="level-item">
      <a v-if="hasHelp" @click="showHelpModal" class="">
        <span class="hide-mobile">{{ $t('Ayuda') }}</span>
        <img src="~@/assets/icons/fa-question.svg" style="margin-left: 5px; height: 20px;" />
      </a>
    </div>
    <div class="prev-button level-item">
      <a v-if="hasPrev" @click.prevent="goPrev">
        <b-icon pack="" icon="chevron-left" size="is-large"> </b-icon>
        <span class="hide-mobile">{{ $t('Volver') }}</span>
      </a>
    </div>
    <div class="next-button level-item">
      <a v-if="hasNext" @click.prevent="goNext">
        <span class="hide-mobile">{{ $t('Seguir') }}</span>
        <b-icon pack="" icon="chevron-right" size="is-large" />
      </a>
    </div>
    <div class="level-item"></div>
  </nav>
</template>

<script>
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'

export default {
  mixins: [OnBoardStepMixin],
  mounted: function() {},
  computed: {
    hasPrev() {
      return this.$route.meta.prev != null
    },
    hasNext() {
      return this.$route.meta.next != null
    },
    showNext() {
      return this.$route.meta.showNext === true
    },
    hasHelp() {
      return (
        this.$route.meta.extra &&
        typeof this.$route.meta.extra.help !== 'undefined'
      )
    },
    domain() {
      return this.$store.state.domain
    }
  },
  methods: {
    goPrev() {
      if (this.$router) this.$router.push({ name: this.$route.meta.prev })
    },
    goNext() {
      if (this.$router) this.$router.push({ name: this.$route.meta.next })
    }
  }
}
</script>

<style scoped lang="scss">
.navbar {
  background: var(--rosa-dark-eco);
  /*padding: 0 20% !important;*/
  box-shadow: 0 0 20px -10px;

  span {
    color: white;
    font-weight: bold;
  }
}

@media (max-width: 1024px) {
  .navbar {
    padding: 0 5% !important;
    box-shadow: 0 0 20px #00000044;
  }
}

.level-item {
  margin-bottom: 0;
}
.prev-button a,
.next-button a {
  transition: 0.2s;
  display: flex;

  span {
    margin: auto;
  }
}
.next-button a:hover {
  transform: translateX(10px);
  padding-left: 30px !important;
  transition: 0.4s;
}
.prev-button a:hover {
  transform: translateX(-10px);
  padding-right: 30px;
  transition: 0.4s;
}

@media (max-width: 768px) {
  .hide-mobile {
    display: none;
  }
}

/*ANIMACION titulo animation title*/
.navbar-item {
  animation-name: title-slide;
  animation-duration: 1s;
  padding-top: 0;
  padding-bottom: 0;

  &:hover {
    background: none;
    text-shadow: 0 0 10px white;
  }
}
@keyframes title-slide {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
